import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["scheduleDay", "scheduleTimeStart", "scheduleTimeEnd", "scheduleCheckbox", "startAt", "unsubscribeSentence"]
  }

  static get values() {
    return {
      scheduleDays: Array,
      scheduleTimeStart: Number,
      scheduleTimeEnd: Number,
      startAtDate: String,
      unsubscribeSentence: String,
    }
  }

  save(event) {
    event.preventDefault()

    let nextUrl = event.target.getAttribute("data-campaign--save-settings-next-url-param")
    let saveUrl = event.target.getAttribute("data-campaign--save-settings-save-url-param")

    let scheduleDays = this.scheduleDayTargets
      .filter((target) => target.checked)
      .map((target) => {
        return parseInt(target.value)
      })

    let scheduleTimeStart = parseInt(this.scheduleTimeStartTarget.value)
    let scheduleTimeEnd = parseInt(this.scheduleTimeEndTarget.value)
    let unsubscribeSentence = this.unsubscribeSentenceTarget.value

    let jsonBody = {}

    if (JSON.stringify(scheduleDays.sort()) !== JSON.stringify(this.scheduleDaysValue.sort())) {
      jsonBody.schedule_days = scheduleDays
    }

    if (scheduleTimeStart !== this.scheduleTimeStartValue) {
      jsonBody.schedule_time_start = scheduleTimeStart
    }

    if (scheduleTimeEnd !== this.scheduleTimeEndValue) {
      jsonBody.schedule_time_end = scheduleTimeEnd
    }

    if (this.scheduleCheckboxTarget.checked && this.startAtDateValue !== this.startAtTarget.value) {
      jsonBody.start_at = this.startAtTarget.value
    } else if (!this.scheduleCheckboxTarget.checked) {
      jsonBody.start_at = null
    }

    if (unsubscribeSentence !== atob(this.unsubscribeSentenceValue)) {
      jsonBody.unsubscribe_sentence = unsubscribeSentence
    }

    if (Object.keys(jsonBody).length === 0) {
      Turbo.visit(nextUrl)
      return
    }

    fetch(saveUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      },
      body: JSON.stringify({
        outreach_settings: jsonBody,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          App.displayFlash("danger", data.error)
        } else {
          Turbo.visit(nextUrl)
        }
      })
  }
}
